{
  "defaultTitle": "チェックインできません",
  "defaultMessage": "配車担当者に情報を確認するか、倉庫にお問い合わせください",
  "backToHomescreen": "ホーム画面に戻る",
  "hideErrorLog": "エラーログを非表示",
  "viewErrorLog": "エラーログを表示",
  "errorLogMessageLabel": "メッセージ：",
  "errorLogStatusLabel": "ステータスコード：",
  "unknown": "不明"
}
